function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { Paywall } from "../../../schema/models";
import { HttpApiEndpoint, HttpApiGroup, HttpApiSchema, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { Predicate, Schema } from "effect";
import { ConflictError, InternalServerError, NotFound, BadRequest, ErrorBaseSchema } from "@superwall/schema-next/api";
export class InvalidPaywall extends Schema.TaggedError()("@superwall/schema/models/errors/InvalidPaywall", _object_spread_props(_object_spread({}, ErrorBaseSchema.fields), {
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/invalid-paywall")
    })
}), HttpApiSchema.annotations({
    status: 400,
    title: "Invalid Paywall",
    description: "The paywall has invalid config data"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/InvalidPaywall");
    }
}
export default HttpApiGroup.make("paywallsv1").annotate(OpenApi.Title, "Paywalls V1").add(HttpApiEndpoint.get("listPaywalls")`/:applicationId`.setPath(Schema.Struct({
    applicationId: Schema.NumberFromString
})).addSuccess(Paywall.List).setUrlParams(Paywall.UrlParams).addError(NotFound).addError(InternalServerError).annotate(OpenApi.Summary, "List Paywalls")).add(HttpApiEndpoint.post("prepareSnapshotForPromotion")`/:id/prepare-snapshot`.setPath(Schema.Struct({
    id: Paywall.Id
})).setPayload(Schema.Struct({
    applicationId: Schema.Number,
    snapshot: Schema.Struct({
        store: Schema.Any,
        schema: Schema.Any
    }),
    bypassProductsMissingValues: Schema.optional(Schema.Boolean)
})).addError(NotFound).addError(BadRequest).addError(InternalServerError).addError(InvalidPaywall).addError(ConflictError).addSuccess(Schema.Struct({
    success: Schema.Boolean,
    data: Schema.Struct({
        snapshotIdentifier: Schema.String
    })
})).annotate(OpenApi.Summary, "Prepare Paywall Snapshot for Promotion")).add(HttpApiEndpoint.post("promoteFromSnapshot")`/:id/promote-from-snapshot`.setPath(Schema.Struct({
    id: Paywall.Id
})).setPayload(Schema.Struct({
    snapshotIdentifier: Schema.String,
    applicationId: Schema.Number
})).addError(NotFound).addError(InternalServerError).addError(ConflictError).addError(BadRequest).addSuccess(Schema.Struct({
    version: Schema.Number
}))).prefix("/v1/paywalls").middleware(Authn) // TODO: HighPrio
 // promoteFromSnapshot
 // getLatestSnapshotByVersion
 // TODO: LowPrio
 // getSnippetResource
 // getPaywallExperimentVariants
 // getLatestResourceByType
 // createOrUpdateResource
 // captureCrash
;
